<template>
  <v-app id="app">
    <v-main>
      <router-view/>
    </v-main>

    <CartMobile v-if="$vuetify.breakpoint.mdAndDown"/>
    <CartDesktop v-else/>

    <v-bottom-sheet v-if="$vuetify.breakpoint.smAndDown" inset max-width="500" scrollable v-model="views.search">
      <SearchModal @close="views.search = false"/>
    </v-bottom-sheet>
    <v-navigation-drawer v-else fixed right temporary v-model="views.search" width="450">
      <SearchModal @close="views.search = false"/>
    </v-navigation-drawer>

    <v-bottom-sheet
      v-if="$vuetify.breakpoint.smAndDown" v-model="views.support" max-width="500" inset persistent scrollable
    >
      <ContactSupport @close="views.support = false"/>
    </v-bottom-sheet>
    <v-navigation-drawer v-else fixed right temporary v-model="views.support" width="550">
      <ContactSupport @close="views.support = false"/>
    </v-navigation-drawer>

    <v-dialog
      v-if="$vuetify.breakpoint.smAndDown" v-model="views.filter"
      fullscreen hide-overlay transition="dialog-bottom-transition"
    >
      <ResultsSearchFilter @close="views.filter = false"/>
    </v-dialog>
    <v-navigation-drawer v-else fixed right temporary v-model="views.filter" width="450">
      <ResultsSearchFilter @close="views.filter = false"/>
    </v-navigation-drawer>
  </v-app>
</template>

<script>
import CartDesktop from "./components/cart/CartDesktop";
import CartMobile from "./components/cart/CartMobile";
import views from "@/mixins/views.js";
import SearchModal from "@/components/SearchModal.vue";
import ContactSupport from "@/components/ContactSupport.vue";
import ResultsSearchFilter from "@/components/Filter.vue";

export default {
  name: 'App',
  mixins: [views],
  components: {
    ResultsSearchFilter,
    ContactSupport,
    SearchModal,
    CartMobile,
    CartDesktop,
  },
  data() {
    return {
      views: {
        search: false,
        support: false,
        filter: false
      }
    }
  },
  metaInfo() {
    if (this.$store.state.merchant?.name) {
      return {
        title: 'Store',
        titleTemplate: `%s • ${ this.$store.state.merchant.name }`
      }
    } else {
      return null
    }
  },
  created() {
    this.setVH();
    window.addEventListener('resize', () => this.setVH());
    this.$bus.$on('modal', (view) => this.showView(view));
  },
  methods: {
    setVH() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${ vh }px`);
    }
  },
}
</script>

<style lang="scss">
@import "assets/global";

.v-main {
  @media (max-width: 960px) {
    background: rgb(236, 239, 241);
  }
}

.nav-spacing {
  padding-top: 115px;
  overflow-y: initial;
  transition: all .15s linear;
}

.nav-spacing-mobile {
  padding-top: 90px;
  overflow-y: initial;
  transition: all .15s linear;
  min-height: calc((var(--vh, 1vh) * 100));
}

.bottom-nav-spacing {
  padding-bottom: 70px !important;
}
</style>
